import React from 'react';
import './Badge.css';

export const Badge = ({ variant = 'info', className = '', children }) => (
  <span className={`ui-badge ui-badge-${variant} ${className}`.trim()}>{children}</span>
);

export default Badge;
